import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import './InputNumber-7d93e963.js';
import './components/shared/Link.es.js';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import { getStyle } from './utils.es.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import { R as Row } from './Col-475038db.js';
import './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import styled from '@emotion/styled';
import { MAPPING_VERTICAL_ALIGNMENT_FLEX } from './constants.es.js';

const StyledPbRow = styled(Row)(({ verticalAlignment, commonStyle, }) => `
  ${getStyle(commonStyle)}
  align-items: ${MAPPING_VERTICAL_ALIGNMENT_FLEX[verticalAlignment] ||
    MAPPING_VERTICAL_ALIGNMENT_FLEX.top};
`);
const PbRow = React.forwardRef((props, ref) => {
    const { commonStyle, children, verticalAlignment, gutter } = props, rest = __rest(props, ["commonStyle", "children", "verticalAlignment", "gutter"]);
    return (jsx(StyledPbRow, Object.assign({ verticalAlignment: verticalAlignment, ref: ref, commonStyle: commonStyle, gutter: gutter || [16, 16] }, rest, { children: children })));
});
PbRow.displayName = Row.displayName;

export { PbRow as P };
